(function ($) {

    $(window).on('load', function () {
        setTimeout(function () {
            if ($('.key-focus').length > 0) {

                setTimeout(function () {
                    $('.key-focus .column-wrapper .img-col .focus-img').each(function (i) {
                        $(this).attr('id', 'focus' + (i + 1));
                    });
                    $('.key-focus .column-wrapper ul li').each(function (i) {
                        $(this).attr('id', 'focus' + (i + 1));
                    });
                    var list = $('.key-focus .column-wrapper .img-col');
                    var listItems = list.children('.focus-img');
                    list.append(listItems.get().reverse());

                }, 200);
                var tabChange = function () {
                    //$('.key-focus .column-wrapper .img-col .focus-img').removeClass('before-active active');
                    $('.key-focus .column-wrapper .img-col .focus-img').removeClass('active');
                    var tabs = $('.key-focus .column-wrapper ul li');
                    var active = tabs.filter('.active');
                    var next = active.next('li').length ? active.next('li') : tabs.filter(':first-child');

                    next.addClass('active');
                    next.siblings().removeClass('active');
                    var index = next.attr('id');

                    //$("#" + index).addClass('before-active').siblings().removeClass('before-active');
                    setTimeout(function () {
                        $("#" + index).addClass('active').siblings().removeClass('active');

                        $('.key-focus .column-wrapper .img-col .focus-img.active').prependTo('.key-focus .column-wrapper .img-col');
                    }, 200);

                }
                // // Tab Cycle function
                var tabCycle = setInterval(tabChange, 5000);

                $(function () {
                    var delay = 200, setTimeoutConst;
                    $('.key-focus .column-wrapper ul li').on('mouseover', function (e) {
                        clearInterval(tabCycle);
                        var clickId = $(this).attr('id');
                        $(this).addClass('active', 200).siblings().removeClass('active', 200);
                        setTimeoutConst = setTimeout(function () {

                            //$("#" + clickId).addClass('before-active').siblings().removeClass('before-active');
                            setTimeout(function () {
                                $("#" + clickId).addClass('active').siblings().removeClass('active');

                                $('.key-focus .column-wrapper .img-col .focus-img.active').prependTo('.key-focus .column-wrapper .img-col');
                            }, 200)
                        }, delay);

                    }).on('mouseleave', function () {
                        clearTimeout(setTimeoutConst);
                        tabCycle = setInterval(tabChange, 5000);
                    });
                });
                $('.key-focus .column-wrapper ul li').on('click', function () {
                    if ($(this).closest('.key-focus-paragraph').length > 0) {
                        return;
                    }
                    var base = window.location.origin;
                    var text = $(this).attr('data-url');
                    var url = base + text;
                    window.location = url;
                });

                var btn = $('.secondary-nav.key .btn-wrapper a');
                $('.key-focus .column-wrapper ul li').on('mouseover click', function () {
                    var $this = $(this);
                    var targetUrl = $this.data('url');
                    if ($this.closest('.key-focus-paragraph').length > 0) {
                        targetUrl = $this.find('a').attr('href') || targetUrl;
                    }
                    btn.attr('href', targetUrl);
                });

                var firstLi = $('.key-focus .column-wrapper .text-col ul li').first();
                if (firstLi.length > 0) {
                    var initial_url = firstLi.data('url');
                    if (firstLi.closest('.key-focus-paragraph').length > 0) {
                        initial_url = firstLi.find('a').attr('href') || initial_url;
                    }
                    btn.attr('href', initial_url);
                }
            }
        }, 200);
    });

})(jQuery);